<template lang="pug">
    div.col-md-4
        div.box
            div.box-header.dker.b-b
                h3 Top Grossing Product
                small Most revenue received from products sales
            div.box-tool
                export-chart(chart="top_revenue" name="Top Grossing Product")

            div.box-body
                chart(:options="options", ref="chart")
</template>

<script>
import { mapGetters } from 'vuex';
import mixins from './mixins';
import Currency from '@js/plugins/currency';

export default {
    mixins: [mixins],

    computed: {
        ...mapGetters('reportProduct', ['chartGrossingProducts']),

        franchiseCurrency() {
            return Currency.hasCurrency();
        },

        options() {
            return {
                title: {
                    show: false,
                },
                color: ['#6887ff'],
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b} <br/> {a} : {c}',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '4%',
                    top: '10%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'value',
                        name: `Sales (${
                            this.$store.getters.currency != null
                                ? this.$store.getters.currency
                                : this.franchiseCurrency
                        })`,
                        nameLocation: 'middle',
                        nameGap: 20,
                    },
                ],
                yAxis: [
                    {
                        type: 'category',
                        data: this.chartGrossingProducts.yAxisData,
                        name: 'Products',
                        nameLocation: 'end',
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLabel: {
                            formatter: (value, index) => {
                                return this.displayShortName(value);
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: `Sales (${
                            this.$store.getters.currency != null
                                ? this.$store.getters.currency
                                : this.franchiseCurrency
                        })`,
                        type: 'bar',
                        barWidth: '60%',
                        data: this.chartGrossingProducts.seriesData,
                    },
                ],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/top-grossing-products.vue